import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface UISlice {
  isShowAssembly: boolean,
  currentDiagram: string,
}

export const sliceInitial: UISlice = {
  isShowAssembly: false,
  currentDiagram: "",
}


//using normalised state shape with Ids in objects instead of arrays as it's quite natural for a database model!
export const uiSlice = createSlice({
    name: 'ui',
    initialState: sliceInitial,
    reducers: {
        toggleShowAssembly: (state) => {
        state.isShowAssembly = !state.isShowAssembly
      },
    setCurrentSVG: (state, action: PayloadAction<string>) => {
  state.currentDiagram = action.payload
      },
    }
})

export const selectShowAssembly = (state: RootState) => state.ui.isShowAssembly
export const selectCurrentDiagram = (state: RootState) => state.ui.currentDiagram

export const {
  toggleShowAssembly,
  setCurrentSVG
} = uiSlice.actions

export default uiSlice.reducer
